import { NgModule } from '@angular/core';
import { PayWithCodeComponent } from './pay-with-code/pay-with-code.component';
import { GoMaterialModule } from '../../go-material.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PaymentCompleteComponent } from './payment-complete/payment-complete.component';
import { ReviewPaymentComponent } from './review-payment/review-payment.component';
import { PayWithCardComponent } from './pay-with-card/pay-with-card.component';
import { ProductDetailsFormComponent } from './product-details-form/product-details-form.component';

@NgModule({
	imports: [
		CommonModule,
		GoMaterialModule,
		TranslateModule,
		FormsModule,
		ReactiveFormsModule
	],
	declarations: [
		PayWithCodeComponent,
		PaymentCompleteComponent,
		ReviewPaymentComponent,
		PayWithCardComponent,
		ProductDetailsFormComponent
	],
	exports: [
		PayWithCodeComponent,
		PaymentCompleteComponent,
		ReviewPaymentComponent,
		PayWithCardComponent,
		ProductDetailsFormComponent
	]
})
export class PaymentPanelModule {}
